import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS } from '../types';
import { getOrLoadCart } from './get-or-load-cart';
import { useHelper } from '../helpers';
export var addToCartRequest = function addToCartRequest() {
  return {
    type: ADD_TO_CART_REQUEST
  };
};
export var addToCartSuccess = function addToCartSuccess(_ref) {
  var cart = _ref.cart,
    product = _ref.product,
    quantity = _ref.quantity,
    sku = _ref.sku;
  return {
    type: ADD_TO_CART_SUCCESS,
    data: cart,
    product: product,
    quantity: quantity,
    sku: sku
  };
};
export var addToCartError = function addToCartError(error) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: ADD_TO_CART_ERROR,
    error: true,
    meta: meta,
    payload: error
  };
};
export var addToCart = function addToCart(items) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var chord, _useHelper, withCart, dispatchAddToCartSuccess, isSingleItem, _updatedCart, _yield$getOrLoadCart, data, updatedCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref2.chord;
            _useHelper = useHelper(dispatch, getState), withCart = _useHelper.withCart;
            dispatchAddToCartSuccess = function dispatchAddToCartSuccess(cart, item) {
              dispatch(addToCartSuccess({
                cart: cart,
                product: item.product,
                quantity: item.quantity,
                sku: item.sku
              }));
            };
            _context.prev = 3;
            isSingleItem = !Array.isArray(items);
            dispatch(addToCartRequest());
            if (!isSingleItem) {
              _context.next = 14;
              break;
            }
            _context.next = 9;
            return withCart(chord.oms.addLineItem)(null, items);
          case 9:
            _context.next = 11;
            return withCart(chord.oms.getOrder)();
          case 11:
            _updatedCart = _context.sent;
            dispatchAddToCartSuccess(_updatedCart, items);
            return _context.abrupt("return", _updatedCart);
          case 14:
            _context.next = 16;
            return getOrLoadCart(dispatch, getState);
          case 16:
            _yield$getOrLoadCart = _context.sent;
            data = _yield$getOrLoadCart.data;
            _context.next = 20;
            return withCart(chord.oms.updateOrder)(null, {
              id: data.id,
              lineItemsAttributes: items
            });
          case 20:
            updatedCart = _context.sent;
            items.forEach(function (i) {
              return dispatchAddToCartSuccess(updatedCart, i);
            });
            return _context.abrupt("return", updatedCart);
          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](3);
            dispatch(addToCartError(_context.t0, items));
            throw _context.t0;
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 25]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};